import apiService from './api';

const consultationCareReferralService = {
  list(consultationId) {
    return apiService.get(`/consultations/${consultationId}/care-referrals`);
  },

  sync(consultationId, referrals, clinicalHospital, clinicalOphthalmology, clinicalPediatrics, clinicalOptical) {
    return apiService.put(`/consultations/${consultationId}/care-referrals`, {
      referrals,
      clinical_information_hospital: clinicalHospital ?? null,
      clinical_information_ophthalmology: clinicalOphthalmology ?? null,
      clinical_information_pediatrics: clinicalPediatrics ?? null,
      clinical_information_optical: clinicalOptical ?? null
    });
  }
};

export default consultationCareReferralService;
